<template>
  <div class="privacy-page">
    <div class="privacy-container">
      <div class="privacy-header">
        <h1>隐私政策</h1>
        <p class="effective-date">生效日期：2026年5月10日</p>
        <p class="parties">贵州省韦小布文艺创作工作室（韦小布AI）</p>
      </div>
      <div class="privacy-content">
        <section class="privacy-section">
          <h2>一、信息收集</h2>
          <p>1.1 韦小布AI平台（以下简称"我们"）可能收集以下类型的信息：</p>
          <ul>
            <li><strong>注册信息</strong>：您在注册时提供的邮箱地址信息。</li>
            <li><strong>使用信息</strong>：您在使用我们服务时生成的提示词、生成记录、操作日志等。</li>
            <li><strong>支付信息</strong>：购买订阅服务时的支付记录和订单信息。</li>
            <li><strong>上传内容</strong>：您上传用于AI图片编辑的参考图片。</li>
          </ul>
          <p>1.2 我们不会以欺骗或误导的方式收集您的信息。</p>
        </section>

        <section class="privacy-section">
          <h2>二、信息使用</h2>
          <p>2.1 我们收集的信息将用于以下目的：</p>
          <ul>
            <li>为您提供和管理账号服务</li>
            <li>处理和响应您的服务请求</li>
            <li>改进和优化我们的AI生成服务</li>
            <li>进行安全验证和风险防范</li>
            <li>发送服务通知和技术更新</li>
            <li>处理您的支付和订阅事务</li>
            <li>遵守法律法规要求</li>
          </ul>
          <p>2.2 我们不会将您的个人信息用于未经您同意的其他目的。</p>
        </section>

        <section class="privacy-section">
          <h2>三、信息存储与保护</h2>
          <p>3.1 您的个人信息将存储在中华人民共和国境内的服务器上。</p>
          <p>3.2 我们采取以下安全措施保护您的信息：</p>
          <ul>
            <li>使用加密技术传输敏感信息（如密码、支付信息）</li>
            <li>定期更新安全系统和软件</li>
            <li>限制员工访问个人信息的权限</li>
            <li>建立完善的数据备份和恢复机制</li>
          </ul>
          <p>3.3 尽管我们采取了合理的安全措施，但互联网并非绝对安全的环境，我们无法保证信息的绝对安全。</p>
        </section>

        <section class="privacy-section">
          <h2>四、AI生成内容</h2>
          <p>4.1 您在使用我们服务过程中生成的AI内容（包括图片、视频、文案等）的知识产权归您所有。</p>
          <p>4.2 您的AI生成内容将存储在服务器上，我们不会公开或分享您的生成内容，除非：</p>
          <ul>
            <li>您主动分享或公开</li>
            <li>法律法规要求或政府部门要求</li>
            <li>内容涉嫌违规，需要进行安全审核</li>
          </ul>
          <p>4.3 根据《人工智能生成合成内容标识办法》，AI生成的内容将自动添加AI标识，您不得移除该标识。</p>
        </section>

        <section class="privacy-section">
          <h2>五、信息共享与披露</h2>
          <p>5.1 我们不会将您的个人信息出售给第三方。</p>
          <p>5.2 在以下情况下，我们可能会共享或披露您的信息：</p>
          <ul>
            <li>获得您的明确同意</li>
            <li>根据法律法规或司法、行政机关的要求</li>
            <li>与我们的关联公司或合作伙伴共享，以便为您提供服务（将签署保密协议）</li>
            <li>保护我们或用户的合法权益、人身安全或财产安全</li>
          </ul>
        </section>

        <section class="privacy-section">
          <h2>六、Cookie及类似技术</h2>
          <p>6.1 我们可能使用Cookie和类似技术来改善用户体验，包括：</p>
          <ul>
            <li>保持您的登录状态</li>
            <li>记住您的偏好设置</li>
            <li>分析网站使用情况以改进服务</li>
          </ul>
          <p>6.2 您可以通过浏览器设置管理或删除Cookie，但可能影响部分功能的使用。</p>
        </section>

        <section class="privacy-section">
          <h2>七、未成年人保护</h2>
          <p>7.1 我们的服务主要面向成年人。未成年人应在监护人的指导下使用我们的服务。</p>
          <p>7.2 如果我们发现在未获得监护人同意的情况下收集了未成年人的个人信息，我们将尽快删除相关信息。</p>
        </section>

        <section class="privacy-section">
          <h2>八、您的权利</h2>
          <p>根据《中华人民共和国个人信息保护法》，您享有以下权利：</p>
          <ul>
            <li><strong>知情权</strong>：了解我们如何处理您的个人信息</li>
            <li><strong>访问权</strong>：查询我们存储的您的个人信息</li>
            <li><strong>更正权</strong>：发现信息有误时要求更正</li>
            <li><strong>删除权</strong>：在特定情况下要求删除您的个人信息</li>
            <li><strong>注销权</strong>：注销账号并要求删除相关数据</li>
            <li><strong>撤回同意</strong>：撤回您对个人信息处理的同意</li>
          </ul>
          <p>8.2 如需行使上述权利，请通过本政策末尾的联系方式与我们联系。</p>
        </section>

        <section class="privacy-section">
          <h2>九、隐私政策更新</h2>
          <p>9.1 我们可能不时更新本隐私政策。更新后的政策将在平台上公布。</p>
          <p>9.2 对于重大变更，我们将通过网站公告或其他适当方式通知您。</p>
          <p>9.3 您继续使用我们的服务即表示您同意接受更新后的隐私政策。</p>
        </section>

        <section class="privacy-section">
          <h2>十、适用法律与争议解决</h2>
          <p>10.1 本隐私政策的解释和执行适用中华人民共和国法律。</p>
          <p>10.2 因本隐私政策引起的争议，双方应友好协商解决；协商不成的，可向甲方所在地有管辖权的人民法院提起诉讼。</p>
        </section>

        <section class="privacy-section">
          <h2>十一、联系我们</h2>
          <p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式联系我们：</p>
          <ul>
            <li>平台名称：韦小布AI</li>
            <li>运营主体：贵州省韦小布文艺创作工作室</li>
          </ul>
        </section>

        <div class="privacy-footer">
          <p class="last-updated">最后更新日期：2026年5月10日</p>
          <p class="copyright">© 2026 韦小布AI - 贵州省韦小布文艺创作工作室 版权所有</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  background: #0a0e1a;
  padding: 40px 20px;
}

.privacy-container {
  max-width: 900px;
  margin: 0 auto;
  background: #111827;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
  border: 1px solid #1e293b;
}

.privacy-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 2px solid #00d4aa;
}

.privacy-header h1 {
  font-size: 32px;
  color: #00d4aa;
  margin: 0 0 16px 0;
  font-weight: 700;
}

.effective-date {
  color: #94a3b8;
  font-size: 14px;
  margin: 0 0 8px 0;
}

.parties {
  color: #cbd5e1;
  font-size: 15px;
  margin: 4px 0;
}

.privacy-content {
  color: #e2e8f0;
  line-height: 1.8;
}

.privacy-section {
  margin-bottom: 32px;
}

.privacy-section h2 {
  font-size: 20px;
  color: #00d4aa;
  margin: 0 0 16px 0;
  padding-left: 12px;
  border-left: 3px solid #00d4aa;
}

.privacy-section p {
  margin: 8px 0;
  color: #cbd5e1;
  font-size: 14px;
}

.privacy-section ul {
  margin: 8px 0 8px 20px;
  padding: 0;
}

.privacy-section ul li {
  color: #cbd5e1;
  font-size: 14px;
  margin: 6px 0;
  list-style: disc;
}

.privacy-footer {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #1e293b;
  text-align: center;
}

.last-updated {
  color: #94a3b8;
  font-size: 13px;
  margin: 0 0 8px 0;
}

.copyright {
  color: #64748b;
  font-size: 13px;
  margin: 0;
}

@media (max-width: 768px) {
  .privacy-page {
    padding: 20px 10px;
  }

  .privacy-container {
    padding: 24px 16px;
  }

  .privacy-header h1 {
    font-size: 24px;
  }

  .privacy-section h2 {
    font-size: 17px;
  }

  .privacy-section p,
  .privacy-section ul li {
    font-size: 13px;
  }
}
</style>
